import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

var companySwiper = new Swiper(".section1 .swiper", {
    loop: true,
    speed:10000,
    autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
    },
    breakpoints: {
      768: {  //当屏幕宽度小于等于1280
        slidesPerView: 1.4699,
        spaceBetween: '4%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        spaceBetween: 0,
      }
    } 
});

var packagingSwiper = new Swiper(".section3 .swiper", {
    speed:500,
    loop:true,
    navigation: {
        nextEl: ".section3 .next",
        prevEl: ".section3 .prev",
    },
    breakpoints: {
      768: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        spaceBetween: '4.6875%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        spaceBetween: 10,
      }
    } 
});

var title_max = 0; //定义一个默认变量，并赋值为0，用于比较	
$('.section3 .swiper-slide .text').each(function() { //遍历相同样式名的元素
    var title = $(this).height(); //获取每个元素的高度，（可根据需要使用outerHeight、innerHeight）
    title_max = title > title_max ? title : title_max; //比较获取的元素高度值和默认变量，如果比0大，则取获取的值，否则取0
    
});
$('.section3 .swiper-slide .text').height(title_max); //给每一个元素设置相同的高度	


$(".certificate-list .certificate-swiper").eq(0).addClass("active");
$(".certificate-nav li").eq(0).addClass("active");
$(".certificate-nav li").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".certificate-list .certificate-swiper").eq(index).addClass("active").siblings().removeClass("active");
})

$(".certificateSwiper").each(function(){
    var $swiper = $(this);
    var swiper = new Swiper($swiper[0],{
        pagination:{
            // 找当前swiper外面的分页器
            el:$swiper
                .siblings(".swiper-pagination")[0],
            clickable:true
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        speed:800,
        grid: {
            rows: 2,
            fill: 'column'
        },
        breakpoints: {
            // 屏幕宽度小于 600px 时，展示 1 列
            320: {
                slidesPerView: 2,
                spaceBetween: 10,
                slidesPerGroup: 2,
                grid: {
                    rows: 1,
                    fill: 'row'
                },
            },
            // 屏幕宽度小于 1024px 时，展示 2 列
            1024: {
                slidesPerView: 4,
                spaceBetween: 20,
                grid: {
                    rows: 2,
                    fill: 'row'
                },
            },
            // 屏幕宽度大于 1024px 时，展示 5 列
            1025: {
                slidesPerView: 6,
                spaceBetween: 20,
                grid: {
                    rows: 2,
                    fill: 'row'
                },
            },
        },
    });
});

var photoSwiper = new Swiper(".section6 .swiper", {
    speed:500,
    navigation: {
        nextEl: ".section6 .next",
        prevEl: ".section6 .prev",
    },
    breakpoints: {
      768: {  //当屏幕宽度小于等于1280 
        slidesPerView: 2.2455,
        spaceBetween: '3.3195%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        spaceBetween: 0,
      }
    } 
});